module.exports = __webpack_public_path__ + "static/img/0.f7b8151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/0.jpg
// module id = 838w
// module chunks = 0